import { render, staticRenderFns } from "./FormSector.vue?vue&type=template&id=50b948e4"
import script from "./FormSector.vue?vue&type=script&lang=js"
export * from "./FormSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports